import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { BatchUploadModalPage } from './batch-upload-modal.page';

const routes: Routes = [
  {
    path: '',
    component: BatchUploadModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [BatchUploadModalPage]
})
export class BatchUploadModalPageModule {}
